var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-wrapper member-wrap"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  }), _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("View Term Request")]), _c('button', {
    staticClass: "clear-search",
    on: {
      "click": _vm.clearData
    }
  }, [_vm._v("Clear Search")])]), _c('term-request-search', {
    attrs: {
      "filters": _vm.filterQuery,
      "clear": _vm.clear
    },
    on: {
      "onSearch": _vm.filterData
    }
  }), _c('div', {
    staticClass: "row member-card member-card-list"
  }, [_c('div', {
    ref: "memberListing",
    staticClass: "clientsData-wrap"
  }, [_c('div', {
    staticClass: "top-pagination"
  }, [_c('pagination', {
    attrs: {
      "rows": _vm.rows,
      "filters": _vm.filterQuery
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.rows = $event;
      }
    }
  })], 1), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', _vm._l(_vm.columns, function (column) {
    return _c('th', {
      key: column.key,
      attrs: {
        "width": column.width
      }
    }, [_vm._v(" " + _vm._s(column.label) + " ")]);
  }), 0)]), _c('tbody', [_vm.loading ? [_vm._m(0)] : [_vm.rows && _vm.rows.records && _vm.rows.records.length < 1 ? [_vm._m(1)] : _vm._l(_vm.rows.records, function (row) {
    var _row$userInfo, _row$userInfo2, _row$userInfo3, _row$agentInfo, _row$agentInfo2, _row$agentInfo3, _row$plan;

    return _c('tr', {
      key: row.termId
    }, [_c('td', [_vm._v(" " + _vm._s(_vm.issetItem(row.policyId)) + " ")]), _c('td', [row.userInfo && Object.keys(row.userInfo).length ? [_vm._v(" " + _vm._s(_vm.issetItem((_row$userInfo = row.userInfo) === null || _row$userInfo === void 0 ? void 0 : _row$userInfo.fullname))), _c('br'), _vm._v(" " + _vm._s(_vm.issetItem((_row$userInfo2 = row.userInfo) === null || _row$userInfo2 === void 0 ? void 0 : _row$userInfo2.email))), _c('br'), _vm._v(" " + _vm._s(_vm.issetItem((_row$userInfo3 = row.userInfo) === null || _row$userInfo3 === void 0 ? void 0 : _row$userInfo3.phone1))), _c('br')] : [_c('span', [_vm._v("N/A")])]], 2), _c('td', [row.agentInfo && Object.keys(row.agentInfo).length ? [_vm._v(" " + _vm._s(_vm.issetItem((_row$agentInfo = row.agentInfo) === null || _row$agentInfo === void 0 ? void 0 : _row$agentInfo.fullname))), _c('br'), _vm._v(" " + _vm._s(_vm.issetItem((_row$agentInfo2 = row.agentInfo) === null || _row$agentInfo2 === void 0 ? void 0 : _row$agentInfo2.email))), _c('br'), _vm._v(" " + _vm._s(_vm.issetItem((_row$agentInfo3 = row.agentInfo) === null || _row$agentInfo3 === void 0 ? void 0 : _row$agentInfo3.phone1))), _c('br')] : [_c('span', [_vm._v("N/A")])]], 2), _c('td', [_c('strong', [_vm._v("Request Sent date : ")]), _vm._v(" " + _vm._s(_vm.issetItem(row.requestDate)) + " "), _c('br'), _c('strong', [_vm._v("Effective Date :")]), row.policy ? _c('span', [_vm._v(_vm._s(_vm.issetItem(row.policy.effective_date)))]) : _vm._e(), _c('br'), _c('strong', [_vm._v("Requested Termination date :")]), _vm._v(" " + _vm._s(_vm.issetItem(row.termDate)) + " ")]), _c('td', [row.pId == 'ALL' ? [row.plans && row.plans.length > 0 ? _vm._l(row.plans, function (p, index) {
      return _c('span', {
        key: index
      }, [_vm._v(" " + _vm._s(_vm.issetItem(p === null || p === void 0 ? void 0 : p.plan_name_system)) + " ")]);
    }) : [_c('span', [_vm._v("N/A")])]] : [_c('p', [_vm._v(" " + _vm._s(_vm.issetItem((_row$plan = row.plan) === null || _row$plan === void 0 ? void 0 : _row$plan.plan_name_system)))])]], 2), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.issetItem(row.termed_by)))]), row.termed_by === 'Agent' && row.requested_rep ? [_c('br'), _vm._v(" " + _vm._s(_vm.issetItem(row.requested_rep)) + " ")] : _vm._e()], 2), _c('td', [_vm._v(" " + _vm._s(_vm.issetItem(row.termReason)) + " ")]), _c('td', [_c('div', {
      class: {
        'alert alert-success': row.termStatus === 'A',
        'alert alert-danger': row.termStatus === 'R',
        'alert alert-warning': row.termStatus !== 'A' && row.termStatus !== 'R'
      },
      attrs: {
        "role": "alert"
      }
    }, [_vm._v(" " + _vm._s(_vm.getStatusText(row.termStatus)) + " ")])]), _c('td', [_vm.verifySignature(row.signatureUrl) ? _c('div', {
      staticClass: "signature-image",
      on: {
        "click": function click($event) {
          return _vm.openSignature(row.signatureUrl);
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "50px",
        "height": "50px"
      },
      attrs: {
        "src": row.signatureUrl
      }
    })]) : _c('div', {
      staticClass: "signature-image"
    }, [_c('span', [_vm._v("N/A")])])])]);
  })]], 2)])]), _c('pagination', {
    attrs: {
      "rows": _vm.rows,
      "filters": _vm.filterQuery
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.rows = $event;
      }
    }
  })], 1)])], 1), _c('signature-modal', {
    ref: "signatureModal",
    attrs: {
      "is-open": _vm.showSignatureDialog,
      "signature-url": _vm.selectedSignatureUrl
    },
    on: {
      "close": _vm.closeSignatureDialog
    },
    model: {
      value: _vm.showSignatureDialog,
      callback: function callback($$v) {
        _vm.showSignatureDialog = $$v;
      },
      expression: "showSignatureDialog"
    }
  })], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v("Loading...")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v("No records found.")])]);
}]

export { render, staticRenderFns }